export const MAPPN_ACCENT = '#1565C0';

export function uid() {
  return Math.random().toString(36).slice(2, 11);
}

export const STATUS_OPTIONS = [
  { key: 'ide',              label: 'Idé',              color: '#78909C' },
  { key: 'utforskas',        label: 'Utforskas',        color: '#26C6DA' },
  { key: 'definierad',       label: 'Definierad',       color: '#42A5F5' },
  { key: 'under_utveckling', label: 'Under utveckling', color: '#FFA726' },
  { key: 'byggd',            label: 'Byggd',            color: '#66BB6A' },
  { key: 'produktion',       label: 'Produktion',       color: '#2E7D32' },
  { key: 'pausad',           label: 'Pausad',           color: '#FFEE58' },
  { key: 'forkastad',        label: 'Förkastats',       color: '#EF5350' },
];

export const IMPL_OPTIONS = [
  { key: 'native',          label: 'Native',          color: '#2E7D32' },
  { key: 'api_integration', label: 'API-integration', color: '#E65100' },
  { key: 'hybrid',          label: 'Hybrid',          color: '#6A1B9A' },
];

export const TECH_TYPES = [
  { key: 'framework', label: 'Ramverk',  bg: '#1565C0', color: '#fff' },
  { key: 'package',   label: 'Paket',    bg: '#42A5F5', color: '#fff' },
  { key: 'service',   label: 'Tjänst',   bg: '#2E7D32', color: '#fff' },
  { key: 'language',  label: 'Språk',    bg: '#6A1B9A', color: '#fff' },
  { key: 'database',  label: 'Databas',  bg: '#E65100', color: '#fff' },
  { key: 'tool',      label: 'Verktyg',  bg: '#616161', color: '#fff' },
  { key: 'format',    label: 'Format',   bg: '#00838F', color: '#fff' },
  { key: 'other',     label: 'Övrigt',   bg: '#BDBDBD', color: '#000' },
];

export const REF_TYPES = [
  { key: 'saas',        label: 'SaaS',        color: '#2E7D32' },
  { key: 'competitor',  label: 'Konkurrent',  color: '#E65100' },
  { key: 'inspiration', label: 'Inspiration', color: '#6A1B9A' },
  { key: 'internal',    label: 'Intern',      color: '#1565C0' },
  { key: 'article',     label: 'Artikel',     color: '#616161' },
];

export function defaultTechStack() {
  return [
    { id: uid(), name: 'React',       type: 'framework', version: '', url: '', note: '' },
    { id: uid(), name: 'Firebase',    type: 'service',   version: '', url: '', note: '' },
    { id: uid(), name: 'Material-UI', type: 'package',   version: '', url: '', note: '' },
    { id: uid(), name: 'Netlify',     type: 'service',   version: '', url: '', note: '' },
  ];
}

export const DEFAULT_PERSPECTIVES = [
  { name: 'Kund',    color: '#0a66c2', order: 0 },
  { name: 'Internt', color: '#FF6B00', order: 1 },
  { name: 'Bolag',   color: '#2E7D32', order: 2 },
];

export const DEFAULT_CATEGORIES = [
  { name: 'CDE',          color: '#1565C0', order: 0 },
  { name: 'Behörighet',   color: '#6A1B9A', order: 1 },
  { name: 'Mötesstöd',    color: '#00838F', order: 2 },
  { name: 'Rapportering', color: '#E65100', order: 3 },
  { name: 'Övrigt',       color: '#616161', order: 4 },
];
